import * as Yup from "yup";
import cn from "classnames";
import { TextField } from "src/components/FormField/TextField";
import {
  PASSWORD_VALIDATION_SCHEMA,
  REPEAT_NEW_PASSWORD_VALIDATION_SCHEMA,
} from "src/constants/formValidation";
import { formFieldTrns } from "src/components/FormField/trns";
import { IRenderFormField } from "src/@types/form";

const DEFAULT_ERROR_CLASSNAME =
  "absolute -bottom-6 w-full !font-medium text-sm text-center leading-none";

export const PASSWORD_UPDATE_FORM_FIELDS: IRenderFormField[] = [
  {
    name: "newPassword",
    type: "password",
    label: { i18nKey: formFieldTrns.newPassword },
    className: "h-11",
    fieldClassName: "text-sm",
    errorClassName: cn(DEFAULT_ERROR_CLASSNAME, "!-bottom-9"),
    component: TextField,
  },
  {
    name: "repeatNewPassword",
    type: "password",
    label: { i18nKey: formFieldTrns.repeatNewPassword },
    className: "h-11",
    fieldClassName: "text-sm",
    errorClassName: DEFAULT_ERROR_CLASSNAME,
    component: TextField,
  },
];

export const PASSWORD_UPDATE_VALIDATION_SCHEMA = Yup.object().shape({
  newPassword: PASSWORD_VALIDATION_SCHEMA,
  repeatNewPassword: REPEAT_NEW_PASSWORD_VALIDATION_SCHEMA,
});
